/**
 * --------------------------------------------------------------------------
 * Material Style index.umd.js
 * Licensed under MIT (https://github.com/materialstyle/materialstyle/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

import Alert from './src/alert.js'
import Button from './src/button.js'
import Carousel from './src/carousel.js'
import Collapse from './src/collapse.js'
import Dropdown from './src/dropdown.js'
import MaterialTab from './src/material-tab.js'
import Modal from './src/modal.js'
import Navbar from './src/navbar.js'
import Offcanvas from './src/offcanvas.js'
import Popover from './src/popover.js'
import Rainbow from './src/rainbow.js'
import Scrollspy from './src/scrollspy.js'
import SelectField from './src/select-field.js'
import Shape from './src/shape.js'
import Snackbar from './src/snackbar.js'
import Tab from './src/tab.js'
import TextField from './src/text-field.js'
import Toast from './src/toast.js'
import Tooltip from './src/tooltip.js'

export default {
  Alert,
  Button,
  Carousel,
  Collapse,
  Dropdown,
  MaterialTab,
  Modal,
  Navbar,
  Offcanvas,
  Popover,
  Rainbow,
  Scrollspy,
  SelectField,
  Shape,
  Snackbar,
  Tab,
  TextField,
  Toast,
  Tooltip
}
